var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 68,
    viewBox: "0 0 78 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34C0 15.2223 15.2223 0 34 0H43.0667C61.8443 0 77.0667 15.2223 77.0667 34C77.0667 52.7777 61.8443 68 43.0667 68H34C15.2223 68 0 52.7777 0 34Z",
    fill: "#F9B44E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5 24H28.5C27.1193 24 26 25.1193 26 26.5V41.5C26 42.8807 27.1193 44 28.5 44H49.5C50.8807 44 52 42.8807 52 41.5V26.5C52 25.1193 50.8807 24 49.5 24Z",
    stroke: "#1C2752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28L39 35L48 28",
    stroke: "#1C2752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22,
    fill: "white",
    transform: "translate(25 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmessage);
export default __webpack_public_path__ + "static/media/iconmessage.6e27d021ef9774131eb51fa5b0022e22.svg";
export { ForwardRef as ReactComponent };